// extracted by mini-css-extract-plugin
export default {"root":"SortHandler_root__Q4KeJ","dragging":"SortHandler_dragging__E0kUo"};